module.exports = __webpack_public_path__ + "media/sybj.8b3370b9.mp4";